import { render } from "./ErpSaas.vue?vue&type=template&id=7decc34f&scoped=true"
import script from "./ErpSaas.vue?vue&type=script&lang=js"
export * from "./ErpSaas.vue?vue&type=script&lang=js"

import "./ErpSaas.vue?vue&type=style&index=0&id=7decc34f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7decc34f"]])

export default __exports__